import React from 'react'
import TextInput from './form/TextInput'
import JSONImportInput from './form/JSONImportInput'
import WordImportInput from './form/WordImportInput'

import GlobalStorage from './storage/GlobalStorage'

export default class extends React.Component{

  constructor(props)
  {
    super(props);
    this.state = {
      file: null
    }
    this.GS = new GlobalStorage()
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(event) {
    this.GS.getStoryEpisode().coverImage = event.target.files[0];
    this.setState({
      file: URL.createObjectURL(event.target.files[0])
    })
  }

  doAction(item)
  {
    if (item.is_href)
    {
      this.setState({
        href: item.name,
        item: item,
      })
    }

  }

  render()
  {
    return (
        <div style={{padding:`10px 15px`,position: `relative`, height: `100%`, display: `flex`, flexDirection: `column`}}>
          <h3 style={{margin:`15px 0px`}}>故事章節名稱</h3>
          <p>
            <label>章節名稱</label>
            <br/>
            <TextInput
                value={this.GS.getStoryEpisode().project_name}
                onChange={(e) => {
                  this.GS.getStoryEpisode().project_name = e.target.value;
                  this.forceUpdate();
                }}
            />
          </p>

          <p>
            <label>集數</label>
            <br/>
            <TextInput
                value={this.GS.getStoryEpisode().sequence}
                onChange={(e) => {
                  this.GS.getStoryEpisode().sequence = e.target.value;
                  this.forceUpdate();
                }}
            />
          </p>
          
          <p>
            <label>作者電郵</label>
            <br/>
            <TextInput
                value={this.GS.getStoryEpisode().email}
                onChange={(e) => {
                  this.GS.getStoryEpisode().email = e.target.value;
                  this.forceUpdate();
                }}
            />
          </p>

          <p>
            <label>故事封面 (1080 x 1920px)</label>
            <br/>
            <input type="file" accept="image/*" id="story-episode-cover-image" name="cover-image" onChange={this.handleChange}/>
            <img style={{maxWidth:'200px'}} src={this.state.file}/>
          </p>


          <h3>由Word文檔導入故事</h3>          
            <WordImportInput
            onChange={(e, filename) => {
              if (filename)
              {
                alert("已匯入" + filename + "。請點擊右面的播放開始預覽！")
                this.props.onPlay && this.props.onPlay(this.GS.parseStoryEpisodeItemsToJsonObject());  this.props.doSwitch && this.props.doSwitch('Scenes')
              }
            }}/>            

          <h3>重載工作紀錄 (.json)</h3>                        
            <JSONImportInput
            onChange={(e, filename) => {
              if (filename)
              {
                alert("已匯入" + filename + "。請點擊右面的播放開始預覽！")
                this.props.onPlay && this.props.onPlay(this.GS.parseStoryEpisodeItemsToJsonObject());
                this.props.doSwitch && this.props.doSwitch('Scenes')
              }
            }}/>                      
          
          <div>
            {  /*             
              this.GS.getUserEpisodeList().storyEpisodeList.content.map((item)=>{
                return (
                  <button className={"btn btn-primary btn-sm center-block"}
                    onClick ={ (e)=>{
                        this.GS.getStoryEpisode().project_name=item.title;                        
                        this.GS.getStoryEpisode().sequence=item.sequence;
                        this.GS.getStoryEpisode().uuid=item.uuid;                      
                      this.forceUpdate();
                    }}
                  >
                  {item.title}
                  </button>
                )
              })
            */
            }
          </div>

        </div>
    )
  }
}